import React, {useState, useCallback} from 'react';

export const UseToggle = initial => {
    const [open, setOpen] = useState(initial);
    return [open, useCallback((newState) => setOpen(status => newState ?? !status))];
};

export default UseToggle;

